import { t as o } from "./index-c07310bf.js";
import "react";
import "./index-64063129.js";
import "react-dom";
import "./index-efd35e77.js";
import "./auto-scroll-b2de6e53.js";
const H = {
  H1: o.h1,
  H2: o.h2,
  H3: o.h3,
  P: o.p
};
export {
  H as Typography
};
